import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Checkbox } from "antd";
import { apiServices } from "../../services/Api";
import { createUser, postLoginData } from "../../store/Slice/AuthSlice";
import { useDispatch } from "react-redux";

const OnboardingForm = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { state } = location;
  const { phoneNumber } = state;
  // console.log("phoneNumber in Onboarding: ", phoneNumber);
  const navigate = useNavigate();
  const [fullName, setFullName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  //Static states
  const [type, setType] = useState("CUSTOMER");
  const [status, setStatus] = useState("ACTIVE");

  const [userId, setUserId] = useState(1);
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);

  const onCheckboxChange = (e) => {
    setIsTermsAccepted(e.target.checked);
    console.log(`checked = ${e.target.checked}`);
  };

  const handleFullNameChange = (event) => {
    const { value } = event.target;
    setFullName(value);
  };
  useEffect(() => {
    //Split full name into first name and last name
    const nameParts = fullName.split(" ");
    setFirstName(nameParts[0]);
    setLastName(nameParts.slice(1).join(" ")); // Join remaining parts as last name

    // console.log("Name: " + firstName + ' ' + lastName);
  }, [fullName]);

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
    // console.log(email);
  };

  // Function to handle form submission
  const handleSubmit = async () => {
    if (!isTermsAccepted) return;
    try {
      const response = await dispatch(
        createUser({
          email: email,
          firstName: firstName,
          lastName: lastName,
          phoneNumber: phoneNumber,
        })
      ).unwrap();
      console.log("New user response", response);

      try {
        // const userData = await apiServices.post('identity/customerByNumber', {}, { phoneNumber: phoneNumber });
        // console.log("fetching newly created userData in OnboardingForm: ", userData);
        // dispatch(postLoginData(userData));
        if (response?.token) {
          document.cookie = `authToken=${
            response?.token
          }; expires=${1}; path=/`;
        }
        navigate(`/dashboard`);
      } catch (error) {
        console.log(error.message);
      }
    } catch (error) {
      console.log(error.message);
    }
  };
  return (
    <div className="flex items-center justify-center text-[#454545] font-['Roboto',sans-serif] h-screen bg-gradient-to-br from-[#1569AB] via-[#1569AB] to-[#1E8C45]">
      <div className="flex flex-col font-['Roboto',sans-serif] w-[32.6875rem] mx-auto bg-white p-6 rounded-lg gap-8 shadow-[0_0_10px_rgba(0,0,0,0.1)]">
        <div>
          <h2 className="sign-up-heading">Create Account</h2>
          <p className="sign-up-subtext">
            Please fill the information to create your account
          </p>
          <hr className="divider" />
        </div>

        <div className="input-group">
          <span>Full name</span>
          <input
            type="text"
            value={fullName}
            onChange={handleFullNameChange}
            placeholder="Enter your full name"
            className="flex h-11 items-center flex-1 w-full py-2.5 px-3 mb-5 rounded-lg border border-brand-border bg-white text-[#9D9D9D] text-base font-normal leading-normal"
          />
          <span>Email</span>
          <input
            type="text"
            value={email}
            onChange={handleEmailChange}
            placeholder="Enter your email"
            className="flex h-11 items-center flex-1 w-full py-2.5 px-3 mb-5 rounded-lg border border-brand-border bg-white text-[#9D9D9D] text-base font-normal leading-normal"
          />
          {/* <span>Password</span>
                    <input type="text" placeholder="Enter your password" className="input-field input-onboarding" />
                    <span>Confirm Password</span>
                    <input type="password" placeholder="Re-enter your password" className="input-field input-onboarding" /> */}

          <div className="flex items-start">
            <Checkbox
              checked={isTermsAccepted}
              onChange={onCheckboxChange}
              className="mr-2"
            />
            <span className="text-sm">
              I agree to the{" "}
              <a
                href="/terms"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#1569AB] hover:underline"
                onClick={(e) => e.stopPropagation()}
              >
                terms & conditions
              </a>
            </span>
          </div>
        </div>
        <div>
          <button
            onClick={handleSubmit}
            disabled={!isTermsAccepted}
            className={`w-full py-3 px-4 rounded-lg text-white font-medium text-base ${
              isTermsAccepted
                ? "bg-[#1569AB] hover:bg-[#135e96] cursor-pointer transition-colors"
                : "bg-gray-300 cursor-not-allowed"
            }`}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default OnboardingForm;
